<!--
  ~ Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
  ~ This software is the proprietary information of NEXTWELL INTL SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<button pButton icon="ui-icon-filter-list" class="filter-button" [ngClass]="size" (click)="onToggleListFilters()" data-testid="on-toggle-list-filters-btn"></button>
<div class="position-relative">
  <div class="filter-form-wrapper" [ngClass]="size" *ngIf="displayFilterPopup">
    <ng-content></ng-content>
  </div>
</div>
<div class="overlay" [ngClass]="{'d-block-forced' : displayFilterPopup}"
     (click)="hide()">
</div>


